import { ReactElement } from "react";
import { Button, IconButton, Divider, Paper } from "@mui/material";
import {
  Info as InfoIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  RestartAlt as ResetIcon,
} from "@mui/icons-material";

export interface ProjectEditorProps {
  className?: string;
  onViewFiles?: () => void;
  onInfo?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onReset?: () => void;
  buttonText?: string;
  showReset?: boolean;
}

const ProjectEditor = ({
  className = "",
  onViewFiles,
  onInfo,
  onEdit,
  onDelete,
  onReset,
  buttonText = "View Files",
  showReset = false,
}: ProjectEditorProps): ReactElement => {
  return (
    <Paper
      elevation={1}
      className={`flex items-center justify-between p-4 rounded-lg w-fit ${className}`}
      sx={{
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* View Files Button */}
      <Button
        variant="contained"
        onClick={onViewFiles}
        className="bg-[#19C1DB] hover:bg-[#17B1CB] text-white font-semibold px-6 py-2"
        sx={{
          textTransform: "none",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(25, 193, 219, 0.3)",
        }}
      >
        {buttonText}
      </Button>

      {/* Action Icons */}
      <div className="flex items-center gap-1 ml-4">
        <Divider orientation="vertical" flexItem className="h-8 mx-2" />

        <IconButton
          onClick={onInfo}
          className="text-gray-500 hover:text-gray-700"
          size="small"
        >
          <InfoIcon />
        </IconButton>

        <Divider orientation="vertical" flexItem className="h-8 mx-1" />

        <IconButton
          onClick={onEdit}
          className="text-gray-500 hover:text-gray-700"
          size="small"
        >
          <EditIcon />
        </IconButton>

        {showReset && (
          <>
            <Divider orientation="vertical" flexItem className="h-8 mx-1" />

            <IconButton
              onClick={onReset}
              className="text-gray-500 hover:text-gray-700"
              size="small"
            >
              <ResetIcon />
            </IconButton>
          </>
        )}

        <Divider orientation="vertical" flexItem className="h-8 mx-1" />

        <IconButton
          onClick={onDelete}
          className="text-gray-500 hover:text-gray-700"
          size="small"
        >
          <DeleteIcon />
        </IconButton>
      </div>
    </Paper>
  );
};

export default ProjectEditor;
